export const materialBaseLimits = {
    max_rows: 10000,
};
